import { parseImportNumber } from './importer';

/**
 * CANTIDADES (kg, L, piezas) de un Excel (revisión de Alex del 14 oct 2026).
 *
 * La regla «un separador + 3 cifras = miles» vale para el DINERO (un gasto de
 * 1,8 no existe). Para cantidades no: «1.500 kg» puede ser kilo y medio y
 * «0,850» es menos de uno. Aquí:
 *
 *  - «0,850», «12,5», «1.5»: sin duda (empieza por cero o no lleva tres cifras
 *    detrás del separador).
 *  - «1.500.000», «1.234,5»: sin duda (varios separadores).
 *  - «1.500» / «1,500»: DUDA. Se lee con el formato del país de la cuenta
 *    (`decimal` = su separador decimal) y se devuelve también la otra lectura,
 *    para preguntar «¿Son 1.500 o 1,5?».
 */
export interface CantidadLeida {
  /** La lectura con el formato del país. */
  valor: number;
  /** Si hay duda, la otra lectura posible (para preguntar). */
  otra?: number;
}

export function leerCantidad(raw: string | undefined, decimal: ',' | '.'): CantidadLeida | undefined {
  // Fuera espacios y la unidad del final («1.500 kg», «2 pz.»).
  const s = String(raw ?? '').replace(/[\s ]/g, '').replace(/[A-Za-z]+\.?$/, '');
  const m = s.match(/^([1-9]\d{0,2})([.,])(\d{3})$/);
  if (!m) {
    const valor = parseImportNumber(s);
    return valor === undefined ? undefined : { valor };
  }
  const comoDecimal = Number(`${m[1]}.${m[3]}`);
  const comoMiles = Number(`${m[1]}${m[3]}`);
  // «1,000» en México es mil; en España, uno. Se lee como en el país y se pregunta.
  return m[2] === decimal ? { valor: comoDecimal, otra: comoMiles } : { valor: comoMiles, otra: comoDecimal };
}
